import gql from 'graphql-tag';

export default gql`
  mutation($_id: ID!, $serviceItems: [createParcelCostServiceItemArg]) {
    updateParcelCostServiceItem(_id: $_id, serviceItems: $serviceItems) {
      succeed
    }
  }
`;
